module.exports = __webpack_public_path__ + "static/media/connection-error.b0d95315.png";